export const categories = [
    {
        name: "All"
    },
    {
        name: "Handloom",
        subCategories: [
            {
                name: "Rich Cotton"
            },
            {
                name: "Rayon"
            },
            {
                name: "Embroider"
            },
            {
                name: "Puni"
            }
        ]
    },

    {
        name: "Batik",
        subCategories: [
            {
                name: "Normal Oil",
                subSubCategories: [
                    "2 Color",
                    "3 Color"
                ]
            },
            {
                name: "Super Oil",
                subSubCategories: [
                    "3 Color"
                ]
            },
            {
                name: "Java"
            }
        ]
    },

    {
        name: "Cotton",
        subCategories: [
            {
                name: "Screen Printing"
            },
            {
                name: "Lace Cotton Embroider"
            },
            {
                name: "Super Voil Embroider"
            }
        ]
    },

    {
        name: "Best Sellers"
    }
];